



































































































































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import IndicatorModel from '@/models/indicator/indicator.model';
import IndicatorService from '@/services/indicator.service';
import GenericBTable from '@/core/Generics/GenericBTable';
import router from '../../../router';
@Component
export default class IndicatorEdit extends GenericEdit<IndicatorModel>{
  
  indicatorService:IndicatorService = new IndicatorService();
  subIndicators:Array<IndicatorModel> =  [];
  constructor() {
    super();
    this.controller = 'Indicators';
    this.model = new IndicatorModel();
    this.model.indicatorTypeId =Number(this.$route.params.indicatorTypeId);
  }
  created(){
    this.getChildIndicators();

  }
  save(){
      this.model.indicatorTypeId =Number(this.$route.params.indicatorTypeId);
      if(this.model.isCompound){
        this.subIndicators.push(this.model)
        this.indicatorService.save(this.subIndicators).then( resp =>{
        this.$router.push(`${this.$router.currentRoute.path.split('/editar')[0]}`)
        this.operationSuccess();
        });
      }
      else{
        this.validate();
      }
    }
    public validarCodigo(event: any) {
    if(event.keyCode === 32) {
      event.preventDefault();
    }
  }
  getChildIndicators(){
    this.indicatorService.getIndicatorChild(Number(this.$route.params.id)).then( resp =>{
      this.subIndicators = resp;
    })
  }
    addSubInidcator(){
      let foundError = false;
     this.subIndicators.forEach((item: IndicatorModel) => {
      if (!item.name || !item.indicadorNo) {
        this.$buefy.toast.open({
          message:
            "Antes de agregar otro campo debe completar los campos que  tiene vacío",
          queue: false,
          duration: 4000,
          type: "is-danger",
          position: "is-top-right",
        });
        foundError = true;
        return;
      }
    });
    if (foundError) {
      foundError = false;
      return;
    }
    let item =  new IndicatorModel();
    item.indicatorTypeId =Number(this.$route.params.indicatorTypeId);
    this.subIndicators.push(item);
  }
 async removeIndicator(id:number,index){
    debugger
     if (id && id !== 0) {
      this.subIndicators.forEach((item: any) => {
        if (item.id === id){
          item.deleted = true;
           this.repository.delete(id);
        } 
        
      });
    } else this.subIndicators.splice(index, 1);
  }
}
